import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DeviceService } from 'src/app/core/device.service';
import { FlashcardService } from 'src/app/core/flashcard.service';
import { PremiumFeatureDialogService } from 'src/app/core/premium-feature-dialog.service';
import { UserService } from 'src/app/core/user.service';
import { Flashcard } from 'src/app/models/flashcard.model';
import { Learnset } from 'src/app/models/learnset.model';
import { User } from 'src/app/models/user.model';

@Component({
  selector: 'app-create-flashcard',
  templateUrl: './create-flashcard.component.html',
  styleUrls: ['./create-flashcard.component.scss'],
  standalone: false
})
export class CreateFlashcardComponent {

  @Input() learnset?: Learnset;
  @Output() finished: EventEmitter<any> = new EventEmitter<any>();

  user?: User;

  form?: FormGroup;
  isLoading: boolean = false;

  showAiChat: boolean = false;
  deviceSize?: 'mobile' | 'tablet' | 'desktop';

  constructor(
    private fb: FormBuilder,
    private flashcardService: FlashcardService,
    private deviceService: DeviceService,
    private userService: UserService,
    private premiumFeatureDialogService: PremiumFeatureDialogService
  ) {}

  ngOnInit() {
    this.form = this.fb.group({
      front: ['', [Validators.required, Validators.minLength(1)]],
      back: ['', [Validators.required, Validators.minLength(1)]]
    });

    this.userService.getUser().subscribe((user) => this.user = user);
    this.deviceSize = this.deviceService.getDeviceSize();
  }

  saveFlashcard() {
    this.isLoading = true;
    const flashcard: Flashcard = new Flashcard(null, this.form!.get('front')!.value, this.form!.get('back')!.value, '', this.learnset!.id, null);
    this.flashcardService.saveFlashcards([flashcard], 'manually').subscribe(() => {
      this.learnset?.flashcards.push(flashcard);
      this.isLoading = false;
      this.form!.reset();
    });
  }

  handleShowAiChat() {
    if (this.user && this.user.isPremiumUser) {
      this.showAiChat = !this.showAiChat;
    } else {
      this.premiumFeatureDialogService.showDialog('KI-Chat einen Klick weit entfernt', 'Bist du dir während dem Lernkarten erstellen über die perfekte Definition unsicher? Kein Problem. Mit einem Klick kannst du den KI-Chat starten und dir Hilfe geben lassen.');
    }
  }

  generateBackContent() {
    if (this.user && this.user.isPremiumUser) {
      this.flashcardService.generateFlashcardAnswer(this.form!.get('front')!.value).subscribe(result => this.form?.setValue({front: this.form.get('front')!.value, back: result.answer}));
    } else {
      this.premiumFeatureDialogService.showDialog('Antwort mit KI erstellen lassen', 'Erstelle noch schneller die perfekten Lernkarten und lasse dir die Antwort auf deine Frage automatisch mit KI generieren.');
    }
  }

  getControl(control: string) {
    return this.form!.get(control) as FormControl;
  }
}
